<template>
  <svg
    aria-hidden="true"
    width="0"
    height="0"
    style="position: absolute; width: 0; height: 0; overflow: hidden"
  >
    <defs>
      <!-- default ↘ accent gradient -->
      <linearGradient id="gp-accent-br" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stop-color="var(--color-accent-gold)" />
        <stop offset="100%" stop-color="var(--color-accent-magenta)" />
      </linearGradient>

      <!-- optional → accent gradient (if you want a horizontal variant) -->
      <linearGradient id="gp-accent-lr" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stop-color="var(--color-accent-gold)" />
        <stop offset="100%" stop-color="var(--color-accent-magenta)" />
      </linearGradient>
    </defs>
  </svg>
</template>
